import { gql } from '@apollo/client/core';

export const CREATE_JOB_POST = gql`
  mutation CreateJob($jobInput: JobInput!) {
    createJob(jobInput: $jobInput) {
      id
    }
  }
`;
